import React from 'react'
import styled from '@emotion/styled'
import { NoLineBreak } from 'src/components/atoms/NoLineBreak'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import HeadTitle from 'src/components/atoms/HeadTitle'
// images
import circle from 'src/images/top/commmune-circle.svg'

const TopConcept = () => {
  return (
    <Container>
      <ContentsWrapper>
        <WrapperStyle>
          <Message>
            <HeadTitle as="h2">
              <NoLineBreak>オールインワンの</NoLineBreak>
              <NoLineBreak>顧客コミュニティで</NoLineBreak>
              <NoLineBreak>
                <NoLineBreak>カスタマー</NoLineBreak>
                <NoLineBreak>サクセスを</NoLineBreak>
                <NoLineBreak>実現</NoLineBreak>
              </NoLineBreak>
            </HeadTitle>
            <Description>
              <NoLineBreak>commmuneは、</NoLineBreak>
              <NoLineBreak>カスタマーサクセスに</NoLineBreak>
              <NoLineBreak>必要な</NoLineBreak>
              <NoLineBreak>顧客コミュニティを</NoLineBreak>
              <NoLineBreak>ノーコードで構築。</NoLineBreak>
            </Description>
            <Description>
              <NoLineBreak>カスタマーサクセスに</NoLineBreak>
              <NoLineBreak>必要な機能が</NoLineBreak>
              <NoLineBreak>全て備わっているので、</NoLineBreak>
              <NoLineBreak>分析・</NoLineBreak>
              <NoLineBreak>コミュニケーション・</NoLineBreak>
              <NoLineBreak>最適なサポートが</NoLineBreak>
              <NoLineBreak>一つの</NoLineBreak>
              <NoLineBreak>プラットフォームで</NoLineBreak>
              <NoLineBreak>実現可能に。</NoLineBreak>
            </Description>
          </Message>
          <CircleImage
            src={circle}
            alt="コミュニティ・メール・API・イベント・トレーニング・ナレッジベース・アプリ・Q&A"
          />
        </WrapperStyle>
      </ContentsWrapper>
    </Container>
  )
}

const Container = styled.div`
  background-color: ${Styles.color.primary[200]};
`

const WrapperStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${Styles.spacing[11]} 0;
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: ${Styles.spacing[10]} 0;
  }
`

const Message = styled.div`
  text-align: center;
  padding: 0 ${Styles.spacing[7]};
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    text-align: left;
    flex: 1;
    min-width: 0;
    margin: 0 ${Styles.spacing[6]} 0 0;
  }
`

const Description = styled(Typography)`
  margin: ${Styles.spacing[7]} 0;
  font-size: ${Styles.fontSize[300]};
  line-height: 1.8;
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    font-size: ${Styles.fontSize[400]};
  }
`

const CircleImage = styled.img`
  max-width: 400px;
  width: 100%;
  height: auto;
  margin: 0 auto;
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    max-width: 100%;
    width: 50%;
  }
`

export default TopConcept
